import { SerializedError } from '@reduxjs/toolkit';

import { useCallback, useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate, useSearchParams } from 'react-router-dom';

import { authorize, AppDispatch } from '../../redux/internal';

export const AuthorizeUser = () => {
  const [params] = useSearchParams();
  const code = params.get('code') ?? '';
  const navigate = useNavigate();
  const dispatch = useDispatch<AppDispatch>();
  const [errorMessage, setErrorMessage] = useState('');

  const authorizeUser = useCallback(async () => {
    await dispatch(
      authorize({
        code: code,
        grant_type: 'authorization_code',
        redirect_uri: `${window.location.protocol}//${window.location.host}/login`,
      })
    )
      .then(() => {
        navigate('/dashboard');
        return;
      })
      .catch((error: SerializedError) => {
        setErrorMessage(error.message ?? '');
      });
  }, [code, dispatch, navigate]);

  useEffect(() => {
    void authorizeUser();
  }, [authorizeUser]);

  return <p>{errorMessage}</p>;
};
